<template>
  <section class="hero">
    <video class="hero-video" autoplay muted loop playsinline preload="none">
      <source :src="heroVideoSrc" type="video/mp4" />
    </video>

    <div class="hero-bg"></div>

    <div class="hero-inner">
      <div class="hero-left">
        <div class="hero-badge">{{ t('hero.badge') }}</div>

        <h1 class="hero-h1">
          {{ t('hero.titleLine1') }}
          <span class="lime">{{ t('hero.titleLine2') }}</span>
        </h1>

        <p class="hero-sub">{{ t('hero.subtitle') }}</p>

        <div class="hero-btns">
          <button class="btn-primary" @click="scrollToSelection">
            {{ t('hero.ctaPrimary') }}
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7h10M8 3l4 4-4 4" stroke="#0d0f0d" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="btn-secondary" @click="scrollToExamples">
            {{ t('hero.ctaSecondary') }}
          </button>
        </div>

        <div class="hero-trust">
          <div class="hero-trust-item">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            {{ t('hero.trustHistory') }}
          </div>
          <div class="hero-trust-item">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
            {{ t('hero.trustSpeed') }}
          </div>
          <div class="hero-trust-item">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
            </svg>
            {{ t('hero.trustFormat') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/stores/app';

const { t } = useI18n();
const store = useAppStore();

const heroVideoSrc = 'video/cpt_new_intro.mp4';


const scrollToSelection = () => {
  store.setStep('oauth');
};

const scrollToExamples = () => {
  const el = document.querySelector('.report-preview-section') || document.querySelector('.example-reports-section');
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
</script>
